import {
  MenuRenderer,
  Box,
  IconChevron,
  MenuItem,
  Text,
  IconLocation,
  IconTick,
  Strong,
} from 'braid-design-system';

import type { Market } from '../../types';

import { useMarkets } from './utils';

interface Props {
  marketSelected: Market;
  onMarketChange: (marketSelected: Market) => void;
  enabledMarkets?: Market[];
  size?: 'small' | 'standard';
}

export const MarketSelector = ({
  marketSelected,
  onMarketChange,
  enabledMarkets,
  size,
}: Props) => {
  const markets = useMarkets(enabledMarkets);

  return (
    <MenuRenderer
      width="large"
      offsetSpace="small"
      reserveIconSpace
      trigger={(triggerProps, { open }) => (
        <Box
          alignItems="center"
          background="surface"
          borderRadius="standard"
          cursor="pointer"
          data={{ testid: 'market-selector-menu' }}
          display="flex"
          justifyContent="spaceBetween"
          paddingX="small"
          style={{ height: size === 'small' ? 42 : 48 }}
          userSelect="none"
          {...triggerProps}
        >
          <Text icon={<IconLocation />} size={size}>
            {mapToLabel(markets, marketSelected)}
          </Text>
          <Text>
            <IconChevron direction={open ? 'up' : 'down'} alignY="lowercase" />
          </Text>
        </Box>
      )}
    >
      {markets.map(({ value, label }) => {
        const isActive = marketSelected === value;

        return (
          <MenuItem
            key={value}
            onClick={() => onMarketChange(value)}
            icon={isActive ? <IconTick /> : undefined}
          >
            {isActive ? <Strong>{label}</Strong> : label}
          </MenuItem>
        );
      })}
    </MenuRenderer>
  );
};

const mapToLabel = (
  markets: Array<{ label: string; value: Market }>,
  value: Market,
): string | undefined => markets.find((m) => m.value === value)?.label;
